import { IOfferState } from '../../redux/reducers';

export const isAreaPartsEmpty = ({ areaParts }: IOfferState) => {
  return !Array.isArray(areaParts) || areaParts.filter(Boolean).length === 0;
};
